import React from "react";
export const AuthContext = React.createContext(null);
export const GlobalContext = React.createContext(null);